import React from 'react';
import { formatMoney } from '../../../../../helpers/DateFormat';

interface TableRow {
    sn: string;
    date_ne: string;
    particular_name: string;
    debitamt: string;
    creditamt: string;
}

interface TableProps {
    data?: TableRow[];
}

const VoucherEntryListView: React.FC<TableProps> = ({ data }) => {
    const totalDebit = data?.reduce((sum, row) => sum + (parseFloat(row.debitamt) || 0), 0) || 0;
    const totalCredit = data?.reduce((sum, row) => sum + (parseFloat(row.creditamt) || 0), 0) || 0;

    return (
        <div className='overflow-auto rounded-md bg-white dark:bg-sky-900'>
            <table className="min-w-full divide-y divide-gray-200 dark:divide-sky-800">
                <thead>
                    <tr>
                        <th className="relative dark:border-[#0c4a6e90] px-2 w-3 py-1 text-left text-[12px] font-semibold text-gray-700 dark:text-gray-200 capitalize tracking-wider">
                            <div className="flex items-center">
                                <span className="select-none text-[12px]">SN</span>
                            </div>
                        </th>
                        <th className="relative dark:border-[#0c4a6e90] px-2 py-1 text-left text-[12px] font-semibold text-gray-700 dark:text-gray-200 capitalize tracking-wider">
                            <div className="flex items-center">
                                <span className="select-none text-[12px]">Date</span>
                            </div>
                        </th>
                        <th className="relative dark:border-[#0c4a6e90] px-2 py-1 text-left text-[12px] font-semibold text-gray-700 dark:text-gray-200 capitalize tracking-wider">
                            <div className="flex items-center">
                                <span className="select-none text-[12px]">Particular Name</span>
                            </div>
                        </th>
                        <th className="relative dark:border-[#0c4a6e90] px-2 py-1 text-left text-[12px] font-semibold text-gray-700 dark:text-gray-200 capitalize tracking-wider">
                            <div className="flex items-center">
                                <span className="select-none text-[12px]">DR</span>
                            </div>
                        </th>
                        <th className="relative dark:border-[#0c4a6e90] px-2 py-1 text-left text-[12px] font-semibold text-gray-700 dark:text-gray-200 capitalize tracking-wider">
                            <div className="flex items-center">
                                <span className="select-none text-[12px]">CR</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody className=''>
                    {data?.map((row, index) => (
                        <tr key={index} className="dark:bg-sky-900 rounded-md hover:cursor-pointer">
                            <td className="px-2 py-1 font-public-sans dark:text-slate-400 whitespace-nowrap text-[12px] text-gray-600 rounded-t-md">
                                {index + 1}.
                            </td>
                            <td className="px-2 py-1 font-public-sans dark:text-slate-400 dark:border-sky-900 whitespace-nowrap text-[12px] text-gray-600 rounded-t-md">
                                {row.date_ne}
                            </td>
                            <td className="px-2 py-1 font-public-sans dark:text-slate-400 dark:border-sky-900 whitespace-nowrap text-[12px] text-gray-600 rounded-t-md">
                                {row.particular_name}
                            </td>
                            <td className="px-2 py-1 font-public-sans dark:text-slate-400 dark:border-sky-900 whitespace-nowrap text-[12px] text-gray-600 rounded-t-md">
                                {formatMoney(parseFloat(row.debitamt?.toString()) || 0)}
                            </td>
                            <td className="px-2 py-1 font-public-sans dark:text-slate-400 dark:border-sky-900 whitespace-nowrap text-[12px] text-gray-600 rounded-t-md">
                                {formatMoney(parseFloat(row.creditamt?.toString()) || 0)}
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="bg-slate-200 dark:bg-sky-800">
                        <td colSpan={3} className="px-2 py-1 font-public-sans text-[12px] text-gray-600 dark:text-gray-300 text-right font-semibold">
                            Total
                        </td>
                        <td className="px-2 py-1 font-public-sans text-[12px] text-gray-600 dark:text-gray-300">
                            {formatMoney(totalDebit)}
                        </td>
                        <td className="px-2 py-1 font-public-sans text-[12px] text-gray-600 dark:text-gray-300">
                            {formatMoney(totalCredit)}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default VoucherEntryListView;
